module.exports = __webpack_public_path__ + "img/nature-3.e543caf4.jpg";